"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./index2.js");exports.Auth=e.Auth,exports.createClient=e.createClient;
